(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpc-product-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpc-copy-button')) {
    customElements.define(
      'tpc-copy-button',
      class TpcCopyButton extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          this.button?.addEventListener('click', () => this.copy());
        }

        async copy() {
          const target = document.getElementById(this.dataset.copyTarget);
          if (!target) return;
          const value = target.textContent.trim();
          try {
            await navigator.clipboard.writeText(value);
          } catch (error) {
            const range = document.createRange();
            range.selectNodeContents(target);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            return;
          }
          const label = this.button.querySelector('.tpc-copy__text');
          const original = label.textContent;
          label.textContent = this.button.dataset.copiedLabel;
          this.status.textContent = `${this.button.dataset.copiedLabel}: ${value}`;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            label.textContent = original;
            this.status.textContent = '';
          }, 2000);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpc-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpc-sticky-atc')) {
    customElements.define(
      'tpc-sticky-atc',
      class TpcStickyAtc extends HTMLElement {
        connectedCallback() {
          const form = document.getElementById(this.dataset.formId);
          this.mainButton = form?.querySelector('[type="submit"][name="add"]');
          if (!this.mainButton) return;
          this.hidden = false;
          this.mq = window.matchMedia('(max-width: 749px)');
          this.ticking = false;
          this.onScroll = () => {
            if (this.ticking) return;
            this.ticking = true;
            requestAnimationFrame(() => {
              this.ticking = false;
              this.update();
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.update();
        }

        update() {
          const passed = this.mainButton.getBoundingClientRect().bottom < 0;
          const show = passed && this.mq.matches && !this.mainButton.disabled;
          this.classList.toggle('is-visible', show);
          document.body.classList.toggle('tpc-has-sticky-atc', show);
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
